import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

const TrackDetailSkeleton = () => {
  return (
    <div>
      <Container className="wlcTrackDetailPage pb-5">
        <Row>
          <Col>
            <Card className="wlcTrackCurrentCard border-0 mb-4">
              <CardBody className="p-4">
                <Row className="align-items-center">
                  <Col style={{ maxWidth: '100px' }}>
                    <Skeleton circle width={72} height={72} />
                  </Col>
                  <Col>
                    <Skeleton width={120} height={14} style={{ marginBottom: '0.5rem' }} />
                    <Skeleton width="65%" height={28} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            {[0, 1, 2].map(index => (
              <Card className="wlcTrackWeekCard border-0 mb-3 background-light-gray" key={index}>
                <CardBody className="p-4">
                  <Row className="align-items-center">
                    <Col xs="9">
                      <Skeleton width={80} height={14} style={{ marginBottom: '0.5rem' }} />
                      <Skeleton width="80%" height={26} style={{ marginBottom: '0.75rem' }} />
                      <Skeleton width={88} height={16} />
                    </Col>
                    <Col xs="3" className="text-right">
                      <Skeleton circle width={64} height={64} />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </Col>
        </Row>
      </Container>

      <div className="background-dark-purple py-5">
        <Container className="wlcTrackDetailPage">
          <Row className="justify-content-center">
            <Col xs={12} lg={10}>
              <Skeleton
                width={220}
                height={28}
                baseColor="#5a1a9e"
                highlightColor="#7b3bbf"
                style={{ marginBottom: '0.75rem' }}
              />
              <Skeleton count={2} baseColor="#5a1a9e" highlightColor="#7b3bbf" style={{ marginBottom: '0.5rem' }} />

              {[0, 1, 2].map(index => (
                <Card className="wlcUpcomingTrackCard border-0 mb-2" key={index}>
                  <CardBody className="py-3 px-4">
                    <Row className="align-items-center">
                      <Col style={{ maxWidth: '100px' }}>
                        <Skeleton circle width={64} height={64} />
                      </Col>
                      <Col>
                        <Skeleton width="60%" height={24} style={{ marginBottom: '0.5rem' }} />
                        <Skeleton width={100} height={14} style={{ marginBottom: '0.75rem' }} />
                        <Skeleton width={180} height={34} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ))}

              <Skeleton width={180} height={48} style={{ marginTop: '1rem' }} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default TrackDetailSkeleton;
